import { Box, CircularProgress, Typography, useTheme } from "@mui/material";

import { useAppSelector } from "../../../../../../hooks/useRedux";
import UserProfileSvg from "../../../../../../media/images/icons/user-profile";

interface TicketAPI {
  answerListData: any;
  answerListMutation: any;
}

const AnswerList = (ticketApi: TicketAPI) => {
  const { answerListData, answerListMutation } = ticketApi;
  const theme = useTheme();
  const { fullName } = useAppSelector((state) => state.user);

  return (
    <Box>
      {!answerListMutation &&
        answerListData?.map((row: any) => (
          <Box
            key={row.id}
            sx={{
              p: "20px 24px 20px 24px ",
              borderRadius: "15px",
              bgcolor:
                fullName === row.reqName ? "background.default" : "#FFECB3",
              width: "94%",
              mr: fullName === row.reqName ? "none" : "auto",
              ml: fullName === row.reqName ? "auto" : "none",
              mb: "10px",
              boxShadow: " 0px 2px 2px 0px rgba(0, 0, 0, 0.05) ",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <UserProfileSvg
                color={
                  fullName === row.reqName
                    ? theme.palette.primary.main
                    : "#212121"
                }
              />

              <Typography
                sx={{
                  color:
                    fullName === row.reqName
                      ? theme.palette.primary.main
                      : "#212121",
                  fontWeight: 700,
                  fontSize: "15px",
                  mr: "8px",
                }}
              >
                {row.reqName}
              </Typography>

              <Typography
                sx={{
                  color:
                    fullName === row.reqName
                      ? theme.palette.primary.main
                      : "#212121",
                  fontWeight: 700,
                  fontSize: "14px",
                  mr: "auto",
                }}
              >
                {new Intl.DateTimeFormat("fa-IR", {
                  dateStyle: "medium",
                }).format(new Date(row.insertDate))}
              </Typography>
            </Box>

            <Typography
              sx={{
                color:
                  fullName === row.reqName
                    ? theme.palette.primary.main
                    : "#212121",
                fontWeight: 700,
                fontSize: "14px",
                mt: "14px",
              }}
            >
              {row.text}
            </Typography>
          </Box>
        ))}

      {answerListMutation && (
        <Box
          sx={{
            width: "100%",
            my: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={50} />
        </Box>
      )}
    </Box>
  );
};

export default AnswerList;
